module.exports = "/wwwroot/img/event_lift_block.png?ver=9a0751f5";